import React from 'react';
import { NestedMenu } from './NestedMenu';
export { dropdownClasses } from './style';
export const Dropdown = React.forwardRef((props, ref) => (React.createElement(NestedMenu, { ...props, ref: ref })));
